//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import axiosApi from '@/request/index'
import {mainUrl,HTTP_IMG_URL} from '@/request/request'
import QuicklyNav from '@/components/quicklyNav'
import {goTop} from '@/mixins/goTop'
import HeadNav from '@/components/headNav'

export default {
    name:"Shop",
    mixins:[goTop],
    components: {
        Swiper,
        SwiperSlide,
        QuicklyNav,
        HeadNav
    },
    directives: {
        swiper: directive
    },
    data(){
        return {
            isShowCode:false,//显示购买的二维码
            goodsDetail:{},
            goodsPrice:{},
            mainUrl,
            HTTP_IMG_URL,
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    },
                },
                //开启循环模式
                loop: true
            },
            PraiseOptions: {
                slidesPerView : 1.2,
                spaceBetween : 20,
            },
            commentQuery:{
                goodsId: "",
                orderRules: [{orderKey: "status", desc: true}, {orderKey: "commentTime", desc: true}],
                size: 5,
                start: 0,
            },
            commentBox:[],
            priceTotal:0,
            shareCode:'',
            showPriceBox:{},//钻石价格
        }
    },
    created(){
        let shopId = this.$route.params.id || '';
        this.goodsId = shopId;
        if(shopId){
            this.getShopDetail(shopId);
            this.getShopPrice(shopId);
            this.getComments(shopId)
            this.getGoodShare(shopId)
        }else{
            this.$vux.toast.div('商品信息错误');
            setTimeout(()=>{
                this.$router.go(-1);
            },1000)
        }
    },

    methods:{
        //立即购买
        goBuy(){
            this.isShowCode=true;
        },
        //获取商品二维码
        getGoodShare(goodsId){
            axiosApi.getGoodShare(goodsId).then(res=>{
                this.shareCode = 'https://ggypupload.oss-cn-shanghai.aliyuncs.com/share/'+res.content
              console.log(this.shareCode)
            })
        },
        //获取商品评价
        getComments(goodsId){
            let commentQuery = this.commentQuery;
            commentQuery.goodsId = goodsId;
            axiosApi.getGoodComments(commentQuery).then(res=>{
                if(res.code==0){
                    this.commentBox =res.content.list;
                    this.priceTotal =res.content.total;
                }
            })
        },
        //获取商品详情
        getShopDetail(goodsId){
            axiosApi.getGoodInfo(goodsId).then(res=>{
                if(res.code==0){
                    this.goodsDetail = res.content;
                }
            })
        },
        //获取商品价格
        getShopPrice(goodsId){
            axiosApi.getGoodPrice(goodsId).then(res=>{
                if(res.code==0){
                    this.showPriceBox = {
                        priceMin:res.content.priceMin,
                        priceMax:res.content.priceMax
                    }
                    // let otherPrices = res.content.otherPrices;
                    // if(otherPrices.length){
                    //     otherPrices.map(item=>{
                    //         if(item.levelStr == '钻石价'){
                    //             this.showPriceBox = item;
                    //         }
                    //     })
                    // }
                }
            })
        }
    },
    filters:{
        priceFilter(price){
            return price?price.toFixed(2):price;
        }
    },
    destroyed(){
        window.removeEventListener('scroll', this.getScroll);
    },
}



// WEBPACK FOOTER //
// ./src/pages/shop/index.vue